
class Startable {
    #_startingProm;
    #_shuttingDownProm;
    #_currentStatus = Startable.STATUSES.UNKNOWN;
    static STATUSES = Object.freeze({
        STARTING: Symbol.for('starting'),
        STARTED: Symbol.for('started'),
        FAILED_TO_START: Symbol.for('failed-to-start'),
        RESTARTING: Symbol.for('restarting'),
        RESTARTED: Symbol.for('restarted'),
        FAILED_TO_RESTART: Symbol.for('failed-to-restart'),
        SHUTTING_DOWN: Symbol.for('shutting-down'),
        SHUTDOWN: Symbol.for('shutdown'),
        FAILED_TO_SHUTDOWN: Symbol.for('failed-to-shutdown'),
        UNKNOWN: Symbol.for('unknown'),
        from: (status) => {
            if (Object.prototype.toString.call(status) === `[object String]`) {
                status = status.toLowerCase();
            }
            const possibleStatuses = Object.values(Startable.STATUSES).toSpliced(-1);
            //If status passed in was a Symbol not a String
            if (possibleStatuses.includes(status)) {
                return status;
            }
            else {
                const found = possibleStatuses.find((possibleStatus) => possibleStatus.description === status);
                if (found) {
                    return found;
                }
                else {
                    return Startable.STATUSES.UNKNOWN;
                }
            }
        }
    });
    /*****************************************************/
    /* START Lifecycle Methods */
    /*****************************************************/
    isStarted() {
        let isStarted = false;
        if (this.statusAsEnum === Startable.STATUSES.STARTED) {
            isStarted = true;
        }
        else if (this.statusAsEnum === Startable.STATUSES.RESTARTED) {
            isStarted = true;
        }
        return isStarted;
    }
    async whenStarted(...theArgs) {
        return this.start(...theArgs);
    }
    async start(...theArgs) {
        if (!this.#_startingProm) {
            this.#_shuttingDownProm = null;
            this.#_startingProm = new Promise(async (resolve, reject) => {
                try {
                    this.#_currentStatus = Startable.STATUSES.STARTING;
                    const result = await this._start(...theArgs);
                    this.#_currentStatus = Startable.STATUSES.STARTED;
                    resolve(result);
                }
                catch (e) {
                    this.#_currentStatus = Startable.STATUSES.FAILED_TO_START;
                    reject(e);
                }
            });
        }
        return this.#_startingProm;
    }
    isRestarted() {
        let isStarted = false;
        if (this.statusAsEnum === Startable.STATUSES.RESTARTED) {
            isStarted = true;
        }
        return isStarted;
    }
    async restart(...theArgs) {
        this.#_shuttingDownProm = null;
        this.#_startingProm = new Promise(async (resolve, reject) => {
            try {
                this.#_currentStatus = Startable.STATUSES.RESTARTING;
                const result = await this._restart(...theArgs);
                this.#_currentStatus = Startable.STATUSES.RESTARTED;
                resolve(result);
            }
            catch (e) {
                this.#_currentStatus = Startable.STATUSES.FAILED_TO_RESTART;
                reject(e);
            }
        });
        return this.#_startingProm;
    }
    isShutdown() {
        return this.statusAsEnum === Startable.STATUSES.SHUTDOWN;
    }
    async whenShutdown(...theArgs) {
        return this.shutdown(...theArgs);
    }
    async shutdown(...theArgs) {
        if (!this.#_shuttingDownProm) {
            this.#_startingProm = null;
            this.#_shuttingDownProm = new Promise(async (resolve, reject) => {
                try {
                    this.#_currentStatus = Startable.STATUSES.SHUTTING_DOWN;
                    const result = await this._shutdown(...theArgs);
                    this.#_currentStatus = Startable.STATUSES.SHUTDOWN;
                    resolve(result);
                }
                catch (e) {
                    this.#_currentStatus = Startable.STATUSES.FAILED_TO_SHUTDOWN;
                    reject(e);
                }
            });
        }
        return this.#_shuttingDownProm;
    }
    isUnknown() {
        return this.statusAsEnum === Startable.STATUSES.UNKNOWN;
    }
    /*****************************************************/
    /* END Lifecycle Methods */
    /* START ABSTRACT METHODS TO BE OVERRIDDEN */
    /*****************************************************/
    async _restart() {
    }
    async _start() {
    }
    async _shutdown() {
    }
    /*****************************************************/
    /* END ABSTRACT METHODS TO BE OVERRIDDEN */
    /* START Class Properties */
    /*****************************************************/
    get status() {
        return this.statusAsEnum.description.toUpperCase();
    }
    get statusAsEnum() {
        return Startable.STATUSES.from(this.#_currentStatus);
    }
    /*****************************************************/
    /* END Class Properties */
    /*****************************************************/
}

export { Startable };
export default Startable;